export default __webpack_public_path__ + "static/media/bg_04.1511a986.png";